module.exports = "/_next/static/images/3c589ff5ec835d4a8d4b6c9d4493c4d9-slide-2-small.png";